<template>
    <fieldset>
        <div v-if="model.type == 'email'">
            <h3 class="form-heading">{{ trans('email_password') }}</h3>
            <div class="row">
                <div class="col-md-9">
                    <txt label="change_password" v-model="model.password" ></txt>
                </div>
                <div class="col-md-3" style="padding-top: 24px;">
                    <button @click="post" class="btn btn-primary pull-right"><i class="icon icon-refresh"></i> {{ trans('update') }}</button>
                </div>
                <div class="col-md-12">
                    <a :href="href('/webmail')" class="btn btn-primary" target="_blank"><i class="icon icon-mail"></i> {{ trans('webmail') }}</a>
                </div>
            </div>
        </div>
        <div v-if="model.type == 'forwarder'">
            <h3 class="form-heading">{{ trans('forwarder') }}</h3>
            <div class="section">If you wish to make a change, please delete the forwarder and create a new one.</div>
        </div>
        <div v-if="model.type == 'responder'">
            <h3 class="form-heading">{{ trans('autoresponder') }}</h3>
            <div class="section">If you wish to make a change, please delete the autoresponder and create a new one.</div>
        </div>
    </fieldset>
</template>

<script>
    export default {
        props: {
            name: { default: '' },
        },
        data: function() {
            return {
                model: {
                    public_id: 0,
                    type: '',
                    password: ''
                }
            }
        },
        created() {
            this.$eventHub.$on('setEmail', this.setEmail);
        },
        methods: {
            post(){
                this.$store('/api/email/update', this);
            },
            href(link) {
                return '/email/' + this.model.public_id + link
            },
            setEmail(data) {
                this.model = this.$setData(data, this.model);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('setEmail', this.setEmail);
        }
    }
</script>
